import { Component, Input, OnChanges, SimpleChanges } from '@angular/core';
import { GetSquaredImage, Product } from 'src/app/models/product.model';
import {
  OrderProduct, Order,
  OrderStatus, totalPrice, ordersProductsToString, orderStatusToString
} from 'src/app/models/order.model';
import { Router } from '@angular/router';
import { NgClass, DatePipe } from '@angular/common';

export {
  OrderProduct, DefaultOrderProduct, Order, DefaultOrder,
  OrderStatus, totalPrice, ordersProductsToString, orderStatusToString
} from 'src/app/models/order.model';

@Component({
    selector: 'app-orders-templated-list',
    templateUrl: './orders-templated-list.component.html',
    styleUrls: ['./orders-templated-list.component.css'],
    imports: [NgClass, DatePipe]
})
export class OrdersTemplatedListComponent implements OnChanges {
  router: Router;

  constructor(router: Router) {
    this.router = router;
  }

  @Input()
  orders: Array<Order> = [];

  ordersCollapsed: Array<boolean> = [];

  ngOnChanges(changes: SimpleChanges) {
    if ('orders' in changes) {
      const change = changes['orders'];
      this.updateCollapsedList(change.currentValue);
    }
  }

  getImage(product: Product) {
    return GetSquaredImage(product);
  }

  orderPrice(order: Order) {
    return totalPrice(order);
  }

  orderStatusToString(orderStatus: OrderStatus) {
    return orderStatusToString(orderStatus);
  }

  ordersProductsToString(order: Order) {
    return ordersProductsToString(order);
  }

  setOrderDetailsVisible(visible: boolean, index: number) {
    this.ordersCollapsed[index] = visible;
  }

  updateCollapsedList(orders: Array<Order>): void {
    const newCollapsedList: Array<boolean> = new Array(orders.length);
    for (let i = 0; i < orders.length; i++) {
      if (i >= 0 && i < this.ordersCollapsed.length)
        newCollapsedList[i] = this.ordersCollapsed[i];
      else
        newCollapsedList[i] = true;
    }
    this.ordersCollapsed = newCollapsedList;
  }

  ShowFullDetail() {
    const width = window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth;
    if (width > 768) {
      return true;
    } else {
      return false;
    }
  }

  goToProductDescription(orderProduct: OrderProduct) {
    this.router.navigate(['/shop/' + orderProduct.product.id])
  }
}
